import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { dateFormatter, rupiah } from 'utils/formatter';
import styles from './style.css';

class PurchaseHistoryRow extends Component {
  render() {
    const { payment } = this.props;
    return (
      <tr onClick={this._onClickRow}>
        <td>{dateFormatter(payment.created_at)}</td>
        <td className={styles['col-outlet']}>{payment.outlet_name}</td>
        <td className={`text-right ${styles['col-sale']}`}>
          {this._purchaseHistoryTotalFormatter(payment)}
        </td>
      </tr>
    );
  }

  _purchaseHistoryTotalFormatter = payment => {
    let amount = payment.is_refunded
      ? rupiah(parseFloat(payment.refund_amount).toFixed(0))
      : rupiah(parseFloat(payment.total_collected).toFixed(0));

    if (payment.is_refunded) {
      amount = `(${amount})`;
    }

    return amount;
  };

  _onClickRow = () => {
    this.props.onClickRow(this.props.payment);
  };
}

PurchaseHistoryRow.propTypes = {
  customerDetail: PropTypes.object,
  onClickRow: PropTypes.func,
};

export default PurchaseHistoryRow;
